import { useBlogNavigationContext } from "../blogTabs";
import { BlogCoachCardProvider } from "./blogCoachCard/BlogCoachCardProvider";
import {
  BlogCoachCardImage,
  BlogCoachCardOrganisation,
  BlogCoachCardWrapper,
} from "./blogCoachCard";
import { BlogCoachCardTextsWrapper } from "./blogCoachCard/BlogCoachCardTextsWrapper";
import { BlogCoachCardName } from "./blogCoachCard/BlogCoachCardName";
import { BlogCoachCardFollow } from "./blogCoachCard/BlogCoachCardFollow";
import { MOCK_ARRAY_3 } from "../../../../lib/constants";
import { DefaultLoadingComponent } from "../../../global/defaultLoading/DefaultLoadingComponent";

export const BlogTopicsCoachesCards = () => {
  const { state } = useBlogNavigationContext();
  const coaches = state.coaches;

  if (coaches.rows.length === 0) {
    return (
      <>
        {MOCK_ARRAY_3.map((item) => (
          <DefaultLoadingComponent key={item} height={40} />
        ))}
      </>
    );
  }

  return (
    <>
      {coaches?.rows.map((item, i) => {
        if (i > 2) {
          return;
        }

        return (
          <BlogCoachCardProvider coach={item} key={item.id}>
            <BlogCoachCardWrapper>
              <BlogCoachCardImage />
              <BlogCoachCardTextsWrapper>
                <BlogCoachCardName />
                <BlogCoachCardOrganisation />
              </BlogCoachCardTextsWrapper>

              <BlogCoachCardFollow />
            </BlogCoachCardWrapper>
          </BlogCoachCardProvider>
        );
      })}
    </>
  );
};
